/* eslint-disable angular/window-service */
/**
 * The global module houses high-level, global constants
 * for the application.
 *
 * @module global
 */

angular.module('global', [])
  .config([
    '$provide',
    function ($provide) {
      'use strict';

      // Define and set defaults
      var global = {
        apiPath: '/newman/api',
        proxy: 'http://localhost:4242/api/v1',
        localizationPath: 'dcs/i18n/',
        maximumConcurrantCalls: 5,
        schemasPath: (!window.isDev ? '/' + angular.element('meta[name="version"]').attr('content') : '') + '/js/schemas/',
        name: 'APPLICATION_NAME',
        tagline: 'APPLICATION_TAGLINE',
        copyright: 'APPLICATION_COPYRIGHT',
        landingRoute: 'routes.cases'
      };

      /**
       * Defines high-level, global constants for the MVC application.
       *
       * @attribute GLOBAL
       * @type String
       * @readOnly
       */
      $provide.constant('GLOBAL', global);
    }
  ]);
